import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as settingActions from "../../actions/settingActions";
import * as homePageActions from "../../actions/homePageActions";
import { Container, Row, Col, Form, FormControl } from "react-bootstrap";
import Iframe from "react-iframe";
import { useForm } from "react-hook-form";
import Button from "../../Component/Button";
import Slider from "react-slick";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import DOMPurify from "dompurify";
import "react-quill/dist/quill.snow.css";
import Loading from "../../Component/Loader/DataLoader";
import './SaaS.css'
import { useLocation } from "react-router-dom";


const Index = (props) => {
  const { actions, brand, setting, title } = props;
  const { register, errors, handleSubmit } = useForm();
  const [pageLoadData, setPageLoadData] = useState("");
  const [loader, setLoader] = useState(false);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const type = params.get("is_mobile")


  // const [editorHtml, setEditorHtml] = useState("");

  useEffect(() => {
    const fetchData = () => {
      actions.getSettingData();
      actions.getBrandData();
      window.scrollTo(0, 0);
      document.title = "vLookUp - SaaS";
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "Would like to be a mentor or mentee with us? Queries? Concerns?  Get in touch with us and we will be happy to assist you with your inquiries."
        );
    };
    fetchData();
  }, [actions, title]);


  const unescapeHtml = (escapedHtml) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(escapedHtml, "text/html");
    return doc.body.textContent || "";
  };

  const handlePageLoadData = async () => {
    setLoader(true);
    try {
      const response = await agent.get(API.SAAS);
      //   let rawHtml = response?.data?.data?.description || "";

      // Unescape the encoded HTML
      //   let unescapedHtml = unescapeHtml(rawHtml);

      // Replace &nbsp; (non-breaking space) with regular spaces
      //   unescapedHtml = unescapedHtml.replace(/\u00a0/g, " ");

      // Sanitize the HTML
      //   const cleanHtml = DOMPurify.sanitize(unescapedHtml);

      //   console.log("Clean", cleanHtml);

      // Set for rendering
      setPageLoadData(response?.data?.data?.description || "");
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log("Error ", error.message);
    }
  };



  useEffect(() => {
    handlePageLoadData();
  }, []);

  if (type) {
    const els = document.querySelectorAll(".growWithUsPage");
    const els1 = document.querySelectorAll(".why_choose_mentor .VlookUp_content_List .descraption h3");
    const els2 = document.querySelectorAll(".why_choose_mentor .VlookUp_content_List .descraption p");
    const els3 = document.querySelectorAll(".why_choose_mentor .bold_content_partner a");
    const els4 = document.querySelectorAll(".why_choose_mentor .bold_content_partner")
    console.log("elelelelel", els);

    if (els.length > 0) {
      els.forEach(el => {
        el.style.paddingTop = "0";
      });
    }

    if (els1.length > 0) {
      els1.forEach(els1 => {
        els1.style.textAlign = "center";     // vertical centering
      });
    }

    if (els2.length > 0) {
      els2.forEach(els2 => {
        els2.style.textAlign = "center";     // vertical centering
      });
    }

    if (els3.length > 0) {
      els3.forEach(els3 => {
        els3.style.marginLeft = "0"; 
      });
    }

    if (els4.length > 0) {
      els4.forEach(els4 => {
        els4.style.textAlign = "center"; 
      });
    }
  }


  return (
    <>
      {loader && <Loading />}

      <div dangerouslySetInnerHTML={{ __html: pageLoadData }} />


    </>
  );
};

function mapStateToProps(state) {
  return {
    setting: state.setting,
    brand: state.brand,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign(settingActions, homePageActions),
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
